module.exports = __webpack_public_path__ + "img/e48.46642580.png";